module.exports = __webpack_public_path__ + "about-image.jpg?8561b676452bdbbe5cc923fff294f972";


//////////////////
// WEBPACK FOOTER
// ./assets/images/about-image.jpg
// module id = 858
// module chunks = 0